// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"inputs-module--checkbox--1Wkbj","select":"inputs-module--select--1jPue","text":"inputs-module--text--Q8OED","error":"inputs-module--error--2BPV-"};